define('controller/step/datetime/GridWeeklyDateTimeStep',['require','controller/step/datetime/BaseWeeklyDateTimeStep','view/controller/booking/datetime/grid-weekly/TimeGridWeeklyView','collection/TimeGridCollection','collection/ServiceCollection','collection/ProviderCollection','plugin/category/collection/CategoryCollection','plugin/location/collection/LocationCollection','Config'],function (require) {

    var BaseWeeklyDateTimeStep = require('controller/step/datetime/BaseWeeklyDateTimeStep');
    var TimeGridWeeklyView = require('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyView');
    var TimeGridCollection = require('collection/TimeGridCollection');
    var ServiceCollection = require('collection/ServiceCollection');
    var ProviderCollection = require('collection/ProviderCollection');
    var CategoryCollection = require('plugin/category/collection/CategoryCollection');
    var LocationCollection = require('plugin/location/collection/LocationCollection');
    var Config = require('Config');

    return BaseWeeklyDateTimeStep.extend({

        _locationCollection: null,
        _categoryCollection: null,
        _providerCollection: null,
        _serviceCollection: null,

        _filterProviderId: null,
        _filterServiceId: null,

        initialize: function () {
            BaseWeeklyDateTimeStep.prototype.initialize.call(this);
            
            if (this._bookingModel.get('service_id')) {
                this._filterServiceId = this._bookingModel.get('service_id');
            } else if (this._bookingModel.get('category_id')) {
                this._filterServiceId = 'category_' + this._bookingModel.get('category_id');
            }
            if (this._bookingModel.get('provider_id')) {
                this._filterProviderId = this._bookingModel.get('provider_id');
            } else if (this._bookingModel.get('location_id')) {
                this._filterProviderId = 'location_' + this._bookingModel.get('location_id');
            }

            this._predefined = Config.getInstance().getOption('predefined') || {};
            if (this._predefined.service) {
                this._filterServiceId = this._predefined.service;
            } else if (this._predefined.category) {
                this._filterServiceId = 'category_' + this._predefined.category;
            }
            if (this._predefined.provider) {
                this._filterProviderId = this._predefined.provider;
            } else if (this._predefined.location) {
                this._filterProviderId = 'location_' + this._predefined.location;
            }


            this.listenTo(this._stepManager, 'step:init:service', this.initServiceCollection);
            this.listenTo(this._stepManager, 'step:init:provider', this.initProviderCollection);
            // this.listenTo(this._bookingModel, 'change:count', this._fetchTimeCollection);

            if (Config.getInstance().getPluginStatus('location')) {
                this.listenTo(this._stepManager, 'step:init:location', this.initLocationCollection);
                var locationStep = this._stepManager.getStepObject('location');
                locationStep.triggerInit();
            }

            if (Config.getInstance().getPluginStatus('event_category')) {
                this.listenTo(this._stepManager, 'step:init:category', this._initCategoryCollection);
                var categoryStep = this._stepManager.getStepObject('category');
                categoryStep.triggerInit();
            }

            //this._initFilterCollections();

            var serviceStep = this._stepManager.getStepObject('service');
            var providerStep = this._stepManager.getStepObject('provider');

            serviceStep.triggerInit();
            providerStep.triggerInit();
        },

        initProviderCollection: function (step, collection) {
            this._providerCollection = collection;
        },

        initServiceCollection: function (step, collection) {
            this._serviceCollection = collection;
        },

        initLocationCollection: function (step, collection) {
            this._locationCollection = collection;
        },

        _initCategoryCollection: function (step, collection) {
            this._categoryCollection = collection;
        },

        getView: function () {
            var result = BaseWeeklyDateTimeStep.prototype.getView.apply(this);
        
            if (Config.getInstance().getOption('datepicker_type') == 'top_calendar') {
                this._supportsTimelineNavigation = false;
            }
            
            return result;
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var dates = null;
            if(this._bookingModel.get('start_date')) {
                dates = this._getFromToDates(
                    Date.parseMysqlDate(this._bookingModel.get('start_date'))
                );
            }

            var view = new TimeGridWeeklyView({
                model: this._bookingModel,
                bookingModel: this._bookingModel,
                timeCollection: this._timeCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                waitingListHelperModel: this.getOption('waitingListHelperModel'),

                categoryCollection: this._categoryCollection,
                serviceCollection: this._serviceCollection,
                locationCollection: this._locationCollection,
                providerCollection: this._providerCollection,
                
                filterServiceId: this._filterServiceId,
                filterProviderId: this._filterProviderId,
                predefined: this._predefined,
                datesInterval: dates
            });

            this.listenTo(view, 'timeChanged', this._updateSelectedTime);
            this.listenTo(view, 'change:provider', this._onChangeProviderFilter);
            this.listenTo(view, 'change:service', this._onChangeServiceFilter);

            return view;
        },

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new TimeGridCollection();
        },

        /**
         *  init locations, providers, services collection to filter
         */
        /* //this data already exist from prev steps
        _initFilterCollections: function () {
            this._serviceCollection = new ServiceCollection();
            this._serviceCollection.fetch();

            //TODO skip virtual providers of classes
            this._providerCollection = new ProviderCollection();
            this._providerCollection.fetch();

            if (Config.getInstance().getPluginStatus('location')) {
                this._locationCollection = new LocationCollection();
                this._locationCollection.fetch();
            }

            if (Config.getInstance().getPluginStatus('event_category')) {
                this._categoryCollection = new CategoryCollection();
                this._categoryCollection.fetch();
            }
        }, */

        _requiresFetchingTimeCollection: function () {
            return !_.isEqual(this._currentFetchParams, this._calculateFetchParams());
        },

        _calculateFetchParams: function () {
            if (!this._bookingModel.get('start_date')) {
                return {};
            }

            var dates = this._getFromToDates(
                Date.parseMysqlDate(this._bookingModel.get('start_date'))
            );
            
            var providerIds = null;
            var serviceIds = null;
                        
            var isFilteredByClass = false;
            
            if (this._filterServiceId) {
                if (this._filterServiceId == 'services') {
                    // select only services
                    serviceIds = this._serviceCollection.filter(function (serviceModel) {
                        return !serviceModel.get('class_id');
                    }).map(function (serviceModel) {
                        return serviceModel.id;
                    });
                } else if (this._filterServiceId == 'classes') {
                    // select only classes
                    serviceIds = this._serviceCollection.filter(function (serviceModel) {
                        return serviceModel.get('class_id');
                    }).map(function (serviceModel) {
                        return serviceModel.id;
                    });
                } else {
                    if (/^category_/.test(this._filterServiceId)) {
                        var categoryId = this._filterServiceId.replace(/^category_/, '');
                        var categoryModel = this._categoryCollection.get(categoryId);
                        if (categoryModel) {
                            serviceIds = categoryModel.get('events');
                        } else {
                            serviceIds = [];
                        }
                    } else {
                        serviceIds = [this._filterServiceId];
                        
                        var serviceModel = this._serviceCollection.get(this._filterServiceId);
                        isFilteredByClass = serviceModel && !!serviceModel.get('class_id');
                    }
                }
            }
            
            if (this._filterProviderId && !isFilteredByClass) {
                if (/^location_/.test(this._filterProviderId)) {
                    var locationId = this._filterProviderId.replace(/^location_/, '');
                    var locationModel = this._locationCollection.get(locationId);
                    if (locationModel) {
                        providerIds = locationModel.get('units');
                    } else {
                        providerIds = [];
                    }
                } else {
                    providerIds = [this._filterProviderId];
                }
            }
            
            var result = {
                'from': dates.from.getMysqlDate(),
                'to': dates.to.getMysqlDate(),
                'provider': providerIds,
                'service': serviceIds,
                'count': this._bookingModel.get('count')
            };
            
            var predefined = this.getOption('predefined') || {};
            if (predefined.service || predefined.category) {
                result.predefined_service = true;
            }
            if (predefined.provider || predefined.location) {
                result.predefined_provider = true;
            }
            
            return result;
        },

        /**
         * Fetches time collection from server
         */
        _fetchTimeCollection: function () {
            if (!this._bookingModel.get('start_date')) {
                this._currentFetchParams = {};
                this._timeCollection.reset();
                return;
            }

            var prev = this._prevRequest;

            this._currentFetchParams = this._calculateFetchParams();

            this._prevRequest = this._timeCollection.fetch({
                data: this._currentFetchParams
            });

            if (prev) {
                prev.abort();
            }
        },

        _onChangeProviderFilter: function (providerId) {
            this._filterProviderId = providerId;
            this._updateTimeCollection();
        },

        _onChangeServiceFilter: function (serviceId) {
            this._filterServiceId = serviceId;
            this._updateTimeCollection();
        }

    });

});
